/*
 * Locks fully-discounted (free-gift) line items in the Recharge cart drawer:
 * hides their quantity stepper and remove button so customers can't edit or
 * delete gifts that are tied to a bundle discount (LPOfferGiftConfig / BXGY).
 * No-ops unless the Recharge cart drawer experience is enabled on the page.
 */
(function () {
  "use strict";

  var RC = window.RechargeStorefrontConfig;
  if (!RC || !RC.cart_drawer || !RC.cart_drawer.enabled) return;

  var HOST_ID = "recharge-storefront-experiences__cart-drawer";
  var STYLE_ID = "mmh-gift-lock-style";
  var CSS = "[data-mmh-gift-lock]{display:none!important}";

  var lastCart = null;

  function shadow() {
    var host = document.getElementById(HOST_ID);
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function ensureStyle(sr) {
    if (sr.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = CSS;
    sr.appendChild(s);
  }

  function isGiftItem(item) {
    return (
      !!item &&
      item.final_line_price <= 0 &&
      item.original_line_price > 0
    );
  }

  function lockItem(li) {
    var qtyInput = li.querySelector('input[name="quantity"]');
    var stepper = qtyInput ? qtyInput.parentElement : null;
    var removeBtn = stepper ? stepper.nextElementSibling : null;
    if (stepper && !stepper.hasAttribute("data-mmh-gift-lock")) {
      stepper.setAttribute("data-mmh-gift-lock", "");
    }
    if (removeBtn && !removeBtn.hasAttribute("data-mmh-gift-lock")) {
      removeBtn.setAttribute("data-mmh-gift-lock", "");
    }
  }

  function paint(cart) {
    var sr = shadow();
    if (!sr) return;
    ensureStyle(sr);
    var drawer = sr.querySelector("#cart-drawer");
    if (!drawer || !cart) return;
    var lis = drawer.querySelectorAll('section[role="list"] > div[role="listitem"]');
    if (lis.length !== cart.items.length) return;
    lis.forEach(function (li, i) {
      if (isGiftItem(cart.items[i])) lockItem(li);
    });
  }

  async function refreshAndPaint() {
    try {
      lastCart = await fetch("/cart.js").then(function (r) {
        return r.json();
      });
    } catch (e) {
      return;
    }
    paint(lastCart);
  }

  function onCartEvent(payload) {
    var cart = payload && payload.cart ? payload.cart : null;
    setTimeout(function () {
      if (cart) {
        lastCart = cart;
        paint(cart);
      } else {
        refreshAndPaint();
      }
    }, 60);
  }

  function boot() {
    var pubsubBound = false;
    var rafPending = false;

    function schedulePaint() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        paint(lastCart);
      });
    }

    var tries = 0;
    var iv = setInterval(function () {
      if (!pubsubBound && window.RechargePubSub) {
        pubsubBound = true;
        window.RechargePubSub.subscribe("cart:update", onCartEvent);
        window.RechargePubSub.subscribe("cart:refresh", onCartEvent);
      }

      var host = document.getElementById(HOST_ID);
      if (host && host.shadowRoot && !host.__mmhGiftLockObserved) {
        host.__mmhGiftLockObserved = true;
        new MutationObserver(schedulePaint).observe(host.shadowRoot, {
          childList: true,
          subtree: true,
        });
      }

      if ((pubsubBound && host && host.__mmhGiftLockObserved) || ++tries > 40) {
        clearInterval(iv);
      }
    }, 250);

    refreshAndPaint();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
